import { useState } from "react";
import "./mainPage.css";

function isOpaqueImageClick(event) {
  const targetElement = event.target instanceof Element ? event.target : null;

  if (targetElement?.closest(".page3-option-label")) {
    return true;
  }

  const buttonElement = event.currentTarget;

  if (!(buttonElement instanceof HTMLElement)) {
    return true;
  }

  const imageElement = buttonElement.querySelector("img");

  if (!(imageElement instanceof HTMLImageElement)) {
    return true;
  }

  if (
    !imageElement.complete ||
    imageElement.naturalWidth === 0 ||
    imageElement.naturalHeight === 0
  ) {
    return true;
  }

  const imageRect = imageElement.getBoundingClientRect();

  if (imageRect.width <= 0 || imageRect.height <= 0) {
    return false;
  }

  const clickX = event.clientX - imageRect.left;
  const clickY = event.clientY - imageRect.top;

  if (
    clickX < 0 ||
    clickY < 0 ||
    clickX >= imageRect.width ||
    clickY >= imageRect.height
  ) {
    return false;
  }

  const sampleCanvas = document.createElement("canvas");
  sampleCanvas.width = imageElement.naturalWidth;
  sampleCanvas.height = imageElement.naturalHeight;

  const sampleContext = sampleCanvas.getContext("2d");

  if (!sampleContext) {
    return true;
  }

  sampleContext.drawImage(imageElement, 0, 0);

  const sampleX = Math.floor(
    (clickX / imageRect.width) * imageElement.naturalWidth,
  );
  const sampleY = Math.floor(
    (clickY / imageRect.height) * imageElement.naturalHeight,
  );

  const alpha = sampleContext.getImageData(sampleX, sampleY, 1, 1).data[3];

  return alpha > 8;
}

function createOpaqueClickHandler(action, delayMs = 0) {
  return (event) => {
    if (!isOpaqueImageClick(event)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (delayMs > 0) {
      window.setTimeout(action, delayMs);
      return;
    }

    action();
  };
}

function MainPage() {
  // "page1" | "page2" | "page3" | "page4"
  const [page, setPage] = useState("page1");
  const [isRuPopupOpen, setIsRuPopupOpen] = useState(false);

  const goPage2 = () => setPage("page2");
  const goPage3 = () => setPage("page3");
  const goPage4 = () => setPage("page4");
  const goHome = () => setPage("page1");
  const goQuiz = (questionSetName = "0-3") => {
    const params = new URLSearchParams({ questionSetName });
    window.location.assign(`/quiz?${params.toString()}`);
  };

  const openRuPopup = () => setIsRuPopupOpen(true);
  const closeRuPopup = () => setIsRuPopupOpen(false);

  const isPage1Visible = page === "page1";
  const isPage2Visible = page === "page2";
  const isPage3Visible = page === "page3";
  const isPage4Visible = page === "page4";

  return (
    <div
      className="main-page"
      style={{
        backgroundImage:
          page === "page1"
            ? 'url("/images/P1_BG_01.webp")'
            : 'url("/images/P2_BG_01.webp")',
      }}
    >
      {/* PAGE 1 */}
      <div className={`page1${isPage1Visible ? "" : " hide"}`}>
        <div className="logo-container">
          <img
            className="logo1"
            src="/images/P1_Logo_01.webp"
            alt=""
            aria-hidden="true"
          />
          <img
            className="logo2"
            src="/images/P1_Text_01.webp"
            alt=""
            aria-hidden="true"
          />
        </div>

        <div className="start-btn-container">
          <div className="ru-btn-container">
            <button
              type="button"
              className="ru-btn-trigger"
              aria-label="Open disclaimer and privacy statement"
              onClick={openRuPopup}
            >
              <img
                className="ru-btn"
                src="/images/P1_RU_button_01.webp"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>

          <div className="floatingWrapper">
            <img
              className="start-btn-bg"
              src="/images/P1_Full_bbutton_01.webp"
              alt=""
              aria-hidden="true"
            />
            <button
              className="start-btn"
              type="button"
              aria-label="Start"
              onClick={createOpaqueClickHandler(goPage2)}
            >
              <img
                src="/images/P1_Full_Abutton_01.webp"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>
        </div>
      </div>

      {/* PAGE 2 */}
      <div
        className={`page2${isPage2Visible ? " show" : ""}`}
        aria-hidden={!isPage2Visible}
      >
        <div className="page2-content">
          <div className="page2-description">
            <span>
              3分鐘解鎖育兒風格!
              <br />
              香港基督教服務處神隊友爸爸計劃，透過輕鬆測驗，了解你現時育兒參與情況及爸爸風格，分析結果並獲得個別化建議，成為「最佳神隊友」。
            </span>
          </div>

          <button
            className="page2-start-btn"
            type="button"
            aria-label="Start page 3"
            onClick={createOpaqueClickHandler(goPage3)}
          >
            <img
              className="page2-start"
              src="/images/P2_Start_Button_01.webp"
              alt=""
              aria-hidden="true"
            />
          </button>

          <button
            className="home-btn"
            type="button"
            aria-label="Home"
            onClick={createOpaqueClickHandler(goHome)}
          >
            <img
              className="home-btn-image"
              src="/images/P2_Home_Button_01.webp"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </div>

      {/* PAGE 3 */}
      <div
        className={`page3${isPage3Visible ? " show" : ""}`}
        aria-hidden={!isPage3Visible}
      >
        <div className="page3-content">
          <div className="page3-description">
            <span className="color-blue">你的孩子現在是哪個年齡階段？</span>
          </div>

          <div className="page3-options" aria-label="Age group options">
            <button
              className="page3-option page3-option-main"
              type="button"
              aria-label="準爸爸"
              onClick={createOpaqueClickHandler(goPage4)}
            >
              <img
                className="page3-option-image"
                src="/images/P3_Bu1_01.webp"
                alt=""
                aria-hidden="true"
              />
              <span className="page3-option-label">準爸爸</span>
            </button>

            <div className="page3-option-stack">
              <button
                className="page3-option"
                type="button"
                aria-label="0-3歲"
                onClick={createOpaqueClickHandler(() => goQuiz("0-3"))}
              >
                <img
                  className="page3-option-image"
                  src="/images/P3_Bu2_01.webp"
                  alt=""
                  aria-hidden="true"
                />
                <span className="page3-option-label">0-3歲</span>
              </button>

              <button
                className="page3-option"
                type="button"
                aria-label="4-6歲"
                onClick={createOpaqueClickHandler(() => goQuiz("4-6"))}
              >
                <img
                  className="page3-option-image"
                  src="/images/P3_Bu3_01.webp"
                  alt=""
                  aria-hidden="true"
                />
                <span className="page3-option-label">4-6歲</span>
              </button>

              <button
                className="page3-option"
                type="button"
                aria-label="7歲以上"
                onClick={createOpaqueClickHandler(() => goQuiz("7+"))}
              >
                <img
                  className="page3-option-image"
                  src="/images/P3_Bu4_01.webp"
                  alt=""
                  aria-hidden="true"
                />
                <span className="page3-option-label">7歲以上</span>
              </button>
            </div>
          </div>

          <button
            className="home-btn"
            type="button"
            aria-label="Home"
            onClick={createOpaqueClickHandler(goHome)}
          >
            <img
              className="home-btn-image"
              src="/images/P2_Home_Button_01.webp"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
        <img
          className="page3-deco"
          src="/images/P3_Deco_01.webp"
          alt=""
          aria-hidden="true"
        />
      </div>

      {/* PAGE 4 */}
      <div
        className={`page4${isPage4Visible ? " show" : ""}`}
        aria-hidden={!isPage4Visible}
      >
        <div className="page4-content">
          <div className="page4-description">
            <img
              className="page4-deco"
              src="/images/P3_Bu1_01.webp"
              alt=""
              aria-hidden="true"
            />
            <span className="page4-deco-label">準爸爸</span>
            <span className="page4-description-text">
              以下是一些爸爸常會遇到的情境。
              <br />
              請想像當事情真的發生時，
              <br />
              你準備好迎接這些挑戰了嗎？
            </span>
          </div>
          <div className="page4-actions">
            <div className="left-column">
              <button
                className="page4-start-btn"
                type="button"
                aria-label="Start"
                onClick={createOpaqueClickHandler(() => goQuiz("0-3"), 100)}
              >
                <img
                  className="page4-start-image"
                  src="/images/P4_Start_Button_01.webp"
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </div>
            <div className="right-column">
              <button
                className="back-btn"
                type="button"
                aria-label="Back"
                onClick={createOpaqueClickHandler(goPage3)}
              >
                <img
                  className="back-btn-image"
                  src="/images/P2_Back_Button_01.webp"
                  alt=""
                  aria-hidden="true"
                />
              </button>
              <button
                className="home-btn"
                type="button"
                aria-label="Home"
                onClick={createOpaqueClickHandler(goHome)}
              >
                <img
                  className="home-btn-image"
                  src="/images/P2_Home_Button_01.webp"
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* RU POPUP (Disclaimer / Privacy) */}
      {isRuPopupOpen && (
        <div
          className="popup-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Disclaimer and privacy statement"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) closeRuPopup();
          }}
        >
          <div className="popup-box">
            <button
              type="button"
              className="popup-close"
              aria-label="Close"
              onClick={closeRuPopup}
            >
              ×
            </button>

            <div className="popup-content">
              {`《神隊友爸爸 Super Daddy》線上心理測驗
免責聲明
本網站所提供之心理測驗內容，部分題目及概念參考自「PEACE 父親參與度問卷」相關研究框架，並經整理及適度調整，以配合本計劃之教育及推廣用途。
本測驗旨在促進公眾對父親參與家庭及育兒角色的理解與反思。測驗結果僅供一般性參考及自我了解之用，並不構成任何專業心理評估、診斷或治療建議。測驗結果僅反映使用者於作答時的自我感受或觀點，並不代表全面或客觀的心理狀況。
如使用者對自身或家庭關係狀況有進一步關注或需要專業支援，建議直接尋求合資格之專業人士或相關社會服務機構提供協助。
本網站及相關機構已盡力確保內容之準確性及適切性，惟對於因使用本測驗內容或結果而可能引致之任何直接或間接影響，包括但不限於因依賴測驗結果而作出的任何個人或家庭決定，本網站及相關機構概不承擔任何法律責任。 
本線上心理測驗為香港基督教服務處「神隊友爸爸 Super Daddy」服務計劃之相關活動之一，主要用作社會服務推廣及公眾教育用途，並非以商業牟利為目的。

私隱聲明
本線上心理測驗由香港基督教服務處「神隊友爸爸 Super Daddy」服務計劃提供。本網站尊重並保障使用者的個人私隱，並致力按照香港《個人資料（私隱）條例》之相關原則處理及保護所收集之資料。
在參與本心理測驗及相關活動時，使用者可能需要提供部分個人資料，例如姓名、聯絡電話或電郵地址等，以便本計劃之社工或相關服務人員於日後就服務資訊、活動邀請或支援服務與使用者聯絡及跟進。
所收集之資料僅會用於本服務計劃相關用途，包括服務聯絡、活動安排、服務評估及統計分析，並不會用作任何商業推廣或牟利用途。除非獲得使用者同意或依法例要求，本機構不會向第三方披露任何可識別個人身份之資料。
本網站已採取合理措施保障資料安全，並妥善處理所收集之資料。然而，互聯網傳輸並非完全安全，本網站對因網絡傳輸所產生之任何風險或損失概不承擔法律責任。
使用者如對個人資料之收集或使用方式有任何查詢，或希望查閱、更正或刪除其個人資料，可聯絡本計劃相關服務單位提出申請。所收集之個人資料只會保存至完成相關服務(兩年)安全刪除。提交資料即表示使用者同意香港基督教服務處按本網站之私隱聲明使用有關資料。

版權及研究來源致謝
本線上心理測驗之部分題目概念及研究框架，參考自「PEACE 父親參與度問卷」相關研究成果。本計劃並不代表或聲稱獲得該研究作者或機構之正式認可，相關內容僅作為教育及推廣用途之參考基礎，並已按本計劃需要進行整理及調整。
本網站尊重相關研究及資料來源之知識產權。如對資料引用或內容使用有任何疑問，歡迎與我們聯絡familyties@hkcs.org，以便作出適當處理。
本心理測驗內容僅用作公眾教育及社會服務推廣用途，並無任何商業用途或牟利目的，亦不應作為任何專業研究或政策制定之依據。
`}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MainPage;
